import { gql, useMutation } from '@apollo/client';
import React, { useState } from 'react';
import { Button, Form, WarningBanner, WithLabel } from '@atrocit/scl';
import LoadingOverlay from '../../lib/ui/LoadingOverlay';
import ButtonArea from '../../lib/forms/ButtonArea';
import Modal from '../../lib/ui/Modal';
import SelectConnectionField from '../../lib/selectfields/SelectConnectionField';


export default function ProcessAttachPickupConnectionCommand({ containerTransports, onClose }) {
	const numberOfPickupTerminals = new Set(containerTransports.map(ct => ct.pickupTerminal?.id)).size;
	const numberOfPickupConnections = new Set(containerTransports.map(ct => ct.pickupConnection?.id).filter(id => id != null)).size;
	const numberOfNullPickupConnections = containerTransports.filter(ct => ct.pickupConnection == null).length;
	const numberOfNonNullPickupConnection = containerTransports.filter(ct => ct.pickupConnection != null).length;
	const shouldShowWarningMixedNullConnections = numberOfNullPickupConnections > 0 && numberOfNonNullPickupConnection > 0;

	const [ pickupConnection, setPickupConnection ] = useState(numberOfPickupConnections == 1 ? containerTransports.filter(ct => ct.pickupConnection != null)[0].pickupConnection : null);
	const terminalIds = new Set(containerTransports.map(ct => ct.pickupTerminal?.id).filter(x => x != null));

	const [ attachPickupConnectionMutation, { loading } ] = useMutation(gql`mutation Mutation($containerTransports: [ Int! ]!, $pickupConnection: Int) {
        processAttachPickupConnection(containerTransports: $containerTransports, pickupConnection: $pickupConnection) { id }
	}`);

	return <Modal title="Importconnectie koppelen" onClose={onClose}>
		{loading && <LoadingOverlay />}
		<div style={{ width: 'var(--u-384)' }}>
			<Form onSubmit={() => attachPickupConnectionMutation({ variables: { containerTransports: containerTransports.map(ct => ct.id), pickupConnection: pickupConnection?.id } }).then(onClose)}>
				<div>Importconnectie koppelen voor <span className="bold">{containerTransports.length}</span> container<span>{containerTransports.length > 1 ? 's' : ''}</span></div>

				<div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 'var(--u-8)', padding: 'var(--u-12) 0' }}>
					{numberOfPickupTerminals > 1 && <WarningBanner>Er wordt een nieuwe connectie geselecteerd, maar de containers worden opgehaald op verschillende terminals</WarningBanner>}
					{numberOfPickupConnections > 1 && <WarningBanner>Er worden <span className="bold">{numberOfPickupConnections}</span> verschillende connecties gewijzigd</WarningBanner>}
					{shouldShowWarningMixedNullConnections && <WarningBanner>Let op: <span className="bold">{numberOfNonNullPickupConnection}</span> container(s) hebben al een connectie, <span className="bold">{numberOfNullPickupConnections}</span> nog niet. Alle connecties worden overschreven.</WarningBanner>}
				</div>

				<div className="col-1">
					<div>
						<WithLabel label="Importconnectie">
							<SelectConnectionField terminalIds={terminalIds} onChange={setPickupConnection} value={pickupConnection} inOutBound="INBOUND" />
						</WithLabel>
					</div>
				</div>

				<ButtonArea>
					<Button level="primary" type="submit"><span className="fa fa-check"/>&nbsp; Koppelen</Button>
					<Button onClick={onClose}>Annuleren</Button>
				</ButtonArea>
			</Form>
		</div>
	</Modal>;
}